<p *ngIf="contentType === 'string'">{{confirmationMessage}}</p>
<div *ngIf="contentType === 'HTML'" [innerHTML]="confirmationMessage"></div>

<div *ngIf="error$ | async" class="bg-light-warning rounded border-warning border border-dashed p-6">
  <h4 class="text-danger">There has been an error.</h4>
  <p>{{error$ | async}}</p>
</div>

<div *nzModalFooter>
  <button class="btn btn-light-primary btn-sm me-2" (click)="destroyModal()">Cancel</button>
  <button
    type="button"
    (click)="confirm()"
    id="qrpay_sign_up_submit"
    class="btn btn-sm btn-theme"
  >
    <ng-container *ngIf="(isLoading$ | async) === false">
      <span class="indicator-label">{{submitButton}}</span>
    </ng-container>
    <ng-container *ngIf="isLoading$ | async">
        <span class="indicator-progress" [style.display]="'block'">
          Please wait...
          <span
            class="spinner-border spinner-border-sm align-middle ms-2"
          ></span>
        </span>
    </ng-container>
  </button>
</div>
